import { createApp } from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
import moshaToast from 'mosha-vue-toastify';
import VueCreditCardValidation from 'vue-credit-card-validation';
import mixpanel from 'mixpanel-browser';
import Vue3Lottie from 'vue3-lottie';
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import tracker from './tracker';
import 'mosha-vue-toastify/dist/style.css';

const app = createApp(App);
Sentry.init({
  app,
  dsn: process.env.VUE_APP_SENTRY_URL,
  release: `generic-web_${process.env.VUE_APP_ENV}@${require("../package.json").version}`,
  environment: process.env.VUE_APP_ENV,
  integrations: [
    new Integrations.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
    }),
  ],
  tracesSampleRate: 1.0,
});
// mixpanel
mixpanel.init(process.env.VUE_APP_MIXPANEL, {
  shouldTrackAutomaticEvents: false
});
app.config.globalProperties.$mixpanel = mixpanel;
// tracker.methods.registerProperties(mixpanel);
app.config.globalProperties.$mixpanelEvent = tracker.analytics.events;
app.config.globalProperties.$mixpanelPayload = tracker.analytics.payLoad;

app.config.globalProperties.$trackUuid = tracker.methods.trackUuid;
app.config.globalProperties.$trackEvent = tracker.methods.trackEvent;
app.config.globalProperties.$registerProperties = tracker.methods.registerProperties;

router.afterEach((to, from) => {
  const pageName = to.name || to.path; // Use route name or path as page name
  mixpanel.track('Page View', {
    page: pageName,
    path: to.path,
    referrer: from.path,
    timestamp: new Date().toISOString(),
  });
});

app.use(moshaToast);
app.use(Vue3Lottie);
app.use(VueCreditCardValidation);
app.use(store);
app.use(VueAxios, axios);
app.use(router);
app.config.globalProperties.$filters = {
  formatMoney(amount) {
    if (Intl) {
      const formatted = new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(amount);
      return formatted.replace(/\.00$/, '');
    }
    const value = amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
    return `₹${value.replace(/\.00$/, '')}`;
  },
  roundUTCDay(d) {
    return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate() + (d.getUTCHours() < 24 ? 0 : 1)));
  },
  formatDate(date, dateTime = false) {
    const d = new Date(date);
    const formattedDate = new Date(this.roundUTCDay(d).toISOString());
    if (!formattedDate) return "";
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const day = formattedDate.getDate().toString().padStart(2, "0");
    const monthIndex = formattedDate.getMonth();
    const year = formattedDate.getFullYear();
    const weekDay = formattedDate.getDay();
    const hour = formattedDate.getHours();
    const minute = formattedDate.getMinutes();
    if (dateTime) {
      return `${day} ${monthNames[monthIndex]} ${year}, ${dayNames[weekDay]} ${hour % 12
        }:${minute} ${hour < 12 ? "AM" : "PM"}`;
    }
    return `${day} ${monthNames[monthIndex]} ${year}`;
  },
  copyToClipboard(text) {
    navigator.clipboard.writeText(text).then(() => {
    }, () => {
    });
  },
  gPayCopyToClipboard(text) {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'absolute';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
  },
  extractPinCode(address) {
    if (!address) return null;
    const match = address.match(/\b\d{6}\b/);
    return match ? match[0] : null;
  },
};
store.axios = app.axios;
store.$router = router;
store.$store = store;
app.mount("#app");

export default app;
